//Maps the results of the email-sending cloud functions to what the user is told.

//submitBookingOrder returns { success }. success:false means the order email to
//the rep was not sent (the order itself is still completed).
export const getSubmitOrderToastKind = (result) =>
  result?.success === false ? "warning" : null;

const normaliseEmail = (email) =>
  String(email ?? "")
    .trim()
    .toLowerCase();

//shareBooking returns { success, failedRecipients? }.
//success:true = everything sent. success:false + failedRecipients = those were
//refused and the rest were sent. success:false without the list = nothing sent.
//sentContactIDs are the contacts that should get shareTracking.lastSent.
export const getShareOutcome = (result, contacts) => {
  if (result?.success === true) {
    return {
      kind: "success",
      sentContactIDs: contacts.map((contact) => contact.id),
      failedRecipients: []
    };
  }

  const failedRecipients = Array.isArray(result?.failedRecipients)
    ? result.failedRecipients
    : [];
  const failedEmails = new Set(failedRecipients.map(normaliseEmail));
  const sentContactIDs =
    failedRecipients.length === 0
      ? []
      : contacts
          .filter((contact) => !failedEmails.has(normaliseEmail(contact.email)))
          .map((contact) => contact.id);

  return {
    kind: sentContactIDs.length > 0 ? "partial" : "error",
    sentContactIDs,
    failedRecipients
  };
};
